import RoleStore from './roleStore';
import TenantStore from './tenantStore';
import UserStore from './userStore';
import SessionStore from './sessionStore';
import AccountStore from './accountStore';
import InventoryStore from './inventoryStore';
import CustomerInfoStore from './customerInfoStore';
import InventoryStatusStore from './inventoryStatusStore';

//声明Store,注意value小写开头
export enum Stores {
  RoleStore = 'roleStore',
  TenantStore = 'tenantStore',
  UserStore = 'userStore',
  SessionStore = 'sessionStore',
  AccountStore = 'accountStore',
  InventoryStore = 'inventoryStore',
  CustomerInfoStore = 'customerInfoStore',
  InventoryStatusStore = 'inventoryStatusStore',
}
//初始化Stores
export default function initializeStores() {
  const inventoryStatusStore:InventoryStatusStore = new InventoryStatusStore();
  return {
    [Stores.RoleStore]: new RoleStore(),
    [Stores.TenantStore]: new TenantStore(),
    [Stores.UserStore]: new UserStore(),
    [Stores.SessionStore]: new SessionStore(),
    [Stores.AccountStore]: new AccountStore(),
    [Stores.InventoryStatusStore]: inventoryStatusStore,
    [Stores.InventoryStore]: new InventoryStore(inventoryStatusStore),
    [Stores.CustomerInfoStore]: new CustomerInfoStore()
  };
}
